import { ALTERAR_MARCACAO_RESERVA } from '../types'

export default function alterarMarcacaoReserva (reserva) {
  return {
    type: ALTERAR_MARCACAO_RESERVA,
    payload: reserva
  }
}
